import { Injectable } from '@angular/core';

import { HighlightsMarqueePage } from './highlights-marquee-page.enum';

@Injectable({ providedIn: 'root' })
export class HighlightsMarqueePageService {
    mapPageSource(page: HighlightsMarqueePage): string {
        switch (page) {
            case HighlightsMarqueePage.Lobby:
                return 'homelobby';
            case HighlightsMarqueePage.SportsLobby:
                return 'sportlobby';
            case HighlightsMarqueePage.BetbuilderCarousel:
                return 'betbuilder';
            case HighlightsMarqueePage.EventDetails:
                return 'EventDetails';
            case HighlightsMarqueePage.Competition:
                return 'competition';
            case HighlightsMarqueePage.TeamsPage:
                return 'TeamsPage';
            case HighlightsMarqueePage.TopScreen:
                return 'TopScreen';
        }
    }
}
